import {
  brandEntityId,
  BrandEntityId,
  brandOverlayDataFile,
  BrandOverlayDataFile,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayCreate1VO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayCreate1VO.validationSchema()
  );

  constructor(readonly value: RoomBrandOverlayCreate1) {
    JsonSchemaValidator.assert(RoomBrandOverlayCreate1VO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "data"],
      properties: {
        roomId,
        brandId: brandEntityId,
        data: brandOverlayDataFile
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandOverlayCreate1 {
  roomId: RoomId;
  brandId: BrandEntityId;
  data: BrandOverlayDataFile;
}
